import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/profile/confirm-credit/demo-1.png'
import _imports_1 from '@/assets/profile/confirm-credit/demo-2.png'
import _imports_2 from '@/assets/profile/confirm-credit/demo-3.png'
import _imports_3 from '@/assets/profile/confirm-credit/demo-4.png'


const _hoisted_1 = { class: "CCSubmit__uploadWrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "请上传营业执照片/复印件", -1)
const _hoisted_3 = { class: "CCSubmit__uploadControl" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["disabled", "value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"center"} }, "支持 jpg / jpeg / png 格式，大小不超过5M", -1)
const _hoisted_7 = { class: "CCSubmit__demoList" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "editorForm",
    model: _ctx.formData,
    rules: _ctx.rules,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol,
    style: {"width":"700px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        label: "营业执照",
        required: "",
        name: "url"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_spin, { spinning: _ctx.uploading }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["CCSubmit__virtualControl", { hide: _ctx.formData.url }])
                  }, [
                    _createVNode(_component_app_icon, { type: "upload" })
                  ], 2),
                  _createElementVNode("img", {
                    src: _ctx.formData.url,
                    class: _normalizeClass({ show: _ctx.formData.url })
                  }, null, 10, _hoisted_4),
                  _createElementVNode("input", {
                    type: "file",
                    disabled: _ctx.uploading,
                    name: "idCardA",
                    accept: "image/jpeg,image/png",
                    value: _ctx.fileVal,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChooseCreditImage($event)))
                  }, null, 40, _hoisted_5)
                ]),
                _hoisted_6
              ])
            ]),
            _: 1
          }, 8, ["spinning"]),
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _hoisted_8,
              _createElementVNode("span", null, [
                _createVNode(_component_app_icon, {
                  type: "check",
                  class: "text-success"
                }),
                _createTextVNode(" 正确拍摄 ")
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createElementVNode("span", null, [
                _createVNode(_component_app_icon, {
                  type: "close",
                  class: "text-error"
                }),
                _createTextVNode(" 边框缺失 ")
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createElementVNode("span", null, [
                _createVNode(_component_app_icon, {
                  type: "close",
                  class: "text-error"
                }),
                _createTextVNode(" 照片模糊 ")
              ])
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createElementVNode("span", null, [
                _createVNode(_component_app_icon, {
                  type: "close",
                  class: "text-error"
                }),
                _createTextVNode(" 闪光强烈 ")
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "企业名称",
        required: "",
        name: "enterpriseName"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formData.enterpriseName,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.enterpriseName) = $event)),
            placeholder: "请填写营业执照上的企业名称"
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "统一社会信用代码",
        required: "",
        name: "socialCreditCode"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formData.socialCreditCode,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.socialCreditCode) = $event)),
            placeholder: "请填写企业的统一社会信用代码"
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "法人姓名",
        required: "",
        name: "legalPerson"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formData.legalPerson,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.legalPerson) = $event)),
            placeholder: "请填写营业执照上的法人姓名"
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 7 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"width":"100px"},
            loading: _ctx.submiting,
            disabled: _ctx.submiting,
            onClick: _withModifiers(_ctx.onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_modal, {
        visible: _ctx.serverErrorVisible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.serverErrorVisible) = $event)),
        width: "700px",
        title: "认证错误",
        footer: null
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.serverError), 1)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}